import React, { Component, ReactNode } from 'react';
import { reportError } from '../../config/newrelic';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
  errorContext?: Record<string, string | number | boolean>;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      hasError: false,
      error: null
    };
  }

  static getDerivedStateFromError(error: Error): State {
    return {
      hasError: true,
      error
    };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    // Report error to New Relic with context
    reportError(error, {
      errorType: 'react_error_boundary',
      componentStack: errorInfo.componentStack?.substring(0, 500) || 'unknown',
      timestamp: Date.now(),
      ...(this.props.errorContext || {})
    });

    console.error('Error caught by boundary:', error);
    console.error('Component stack:', errorInfo.componentStack);
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }

      return (
        <div style={{
          padding: '20px',
          textAlign: 'center',
          color: '#721c24',
          backgroundColor: '#f8d7da',
          border: '1px solid #f5c6cb',
          borderRadius: '4px',
          margin: '20px'
        }}>
          <h2>Something went wrong</h2>
          <p>We've been notified and are working to fix the issue.</p>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;

